/**
 * 设计系统预览组件
 * 展示设计系统中的各种组件和样式
 */

import React from 'react';
// import { useDesignSystemViewModel } from '../../viewmodels/DesignSystemViewModel.js';

/**
 * 设计系统预览组件
 */
function DesignSystemPreview() {
  // const { components, tokens } = useDesignSystemViewModel();

  return (
    <div className="space-y-8">
      {/* 颜色系统 */}
      <section>
        <h3 className="text-xl font-semibold text-foreground mb-4">
          颜色系统
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="space-y-2">
            <div className="w-full h-16 bg-primary rounded-lg"></div>
            <p className="text-sm text-muted-foreground">Primary</p>
          </div>
          <div className="space-y-2">
            <div className="w-full h-16 bg-secondary rounded-lg"></div>
            <p className="text-sm text-muted-foreground">Secondary</p>
          </div>
          <div className="space-y-2">
            <div className="w-full h-16 bg-accent rounded-lg"></div>
            <p className="text-sm text-muted-foreground">Accent</p>
          </div>
          <div className="space-y-2">
            <div className="w-full h-16 bg-muted rounded-lg"></div>
            <p className="text-sm text-muted-foreground">Muted</p>
          </div>
        </div>
      </section>

      {/* 按钮组件 */}
      <section>
        <h3 className="text-xl font-semibold text-foreground mb-4">
          按钮组件
        </h3>
        <div className="flex flex-wrap gap-4">
          <button className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
            Primary Button
          </button>
          <button className="px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90">
            Secondary Button
          </button>
          <button className="px-4 py-2 border border-border rounded-md hover:bg-accent">
            Outline Button
          </button>
        </div>
      </section>

      {/* 卡片组件 */}
      <section>
        <h3 className="text-xl font-semibold text-foreground mb-4">
          卡片组件
        </h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="bg-card border border-border rounded-lg p-6">
            <h4 className="text-lg font-medium text-foreground mb-2">
              示例卡片
            </h4>
            <p className="text-muted-foreground">
              这是一个示例卡片，展示了基本的卡片样式和内容布局。
            </p>
          </div>
          <div className="bg-card border border-border rounded-lg p-6">
            <h4 className="text-lg font-medium text-foreground mb-2">
              另一个卡片
            </h4>
            <p className="text-muted-foreground">
              卡片可以包含各种内容，如文本、图片、按钮等。
            </p>
          </div>
        </div>
      </section>

      {/* 表单组件 */}
      <section>
        <h3 className="text-xl font-semibold text-foreground mb-4">
          表单组件
        </h3>
        <div className="max-w-md space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              输入框
            </label>
            <input 
              type="text" 
              placeholder="请输入内容"
              className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              选择框
            </label>
            <select className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary">
              <option>选项 1</option>
              <option>选项 2</option>
              <option>选项 3</option>
            </select>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DesignSystemPreview;